module.exports = __webpack_public_path__ + "img/hr-tree-08-d-trunk.8b9ee24b.png";